window.addEventListener('load', event => {
    // Mobile Menu JS
    let mobilemenuopen = document.getElementById('mobilemenuopen');
    if (mobilemenuopen) {
        mobilemenuopen.addEventListener('click', function() {
            document.getElementById('mobilemenu').classList.remove('hidden');
            setTimeout(function() {
                document.getElementById('mobilemenu').classList.remove('opacity-0', 'scale-95');
                document.getElementById('mobilemenu').classList.add('active');
                document.body.classList.add('mobile-lock-scroll');
            }, 150);
        });
    }

    let mobilemenuclose = document.getElementById('mobilemenuclose');
    if (mobilemenuclose) {
        mobilemenuclose.addEventListener('click', function() {
            document.body.classList.remove('mobile-lock-scroll');
            document.getElementById('mobilemenu').classList.add('opacity-0', 'scale-95');
            setTimeout(function() {
                document.getElementById('mobilemenu').classList.add('hidden');
                document.getElementById('mobilemenu').classList.remove('active');
            }, 150);
        });
    }

    // Apps Modal JS
    let appsmodalopen = document.getElementById('appsmodalopen');
    if (appsmodalopen) {
        appsmodalopen.addEventListener('click', function() {
            document.getElementById('appsmodal').classList.remove('hidden');
            setTimeout(function() {
                document.getElementById('appsmodal').classList.remove('opacity-0', 'scale-95');
                document.getElementById('appsmodal').classList.add('active');
                document.body.classList.add('mobile-lock-scroll-desktop');
            }, 150);
        });
    }

    let appsmodalclose = document.getElementById('appsmodalclose');
    if (appsmodalclose) {
        appsmodalclose.addEventListener('click', function() {
            document.body.classList.remove('mobile-lock-scroll-desktop');
            document.getElementById('appsmodal').classList.add('opacity-0', 'scale-95');
            setTimeout(function() {
                document.getElementById('appsmodal').classList.add('hidden');
                document.getElementById('appsmodal').classList.remove('active');
            }, 150);
        });
    }

    let appsmodal = document.getElementById('appsmodal');
    if (appsmodal) {
        appsmodal.addEventListener('click', function() {
            document.body.classList.remove('mobile-lock-scroll-desktop');
            document.getElementById('appsmodal').classList.add('opacity-0', 'scale-95');
            setTimeout(function() {
                document.getElementById('appsmodal').classList.add('hidden');
                document.getElementById('appsmodal').classList.remove('active');
            }, 150);
        });
    }
});
